import { Action } from "@opstel/query/v2/models/action";
import { OccupationsForTrack } from "@opstel/query/models/occupationsForTrack";
import { TrackOccupation } from "@opstel/query/models/trackOccupation";
import { DateTime } from "luxon";

export type OccupationsForTrackWithOrder = OccupationsForTrack & { track: { maxOrder: number } };
export type TrackWithOrder = OccupationsForTrackWithOrder["track"];

export function processOccupationsForTrack({
  track,
  occupations,
}: OccupationsForTrack): OccupationsForTrackWithOrder {
  const filteredOccupations = filterOccupations(occupations);
  return {
    occupations: filteredOccupations,
    track: {
      ...track,
      maxOrder: getMaxOrder(filteredOccupations),
    },
  };
}

function getMaxOrder(occupations: TrackOccupation[]): number {
  return Math.max(1, ...occupations.map((occupation) => occupation.order));
}

function filterOccupations(occupations: TrackOccupation[]): TrackOccupation[] {
  return occupations
    .map(({ actions, ...occupation }) => ({
      ...occupation,
      actions: actions.filter(actionFilter),
    }))
    .filter((occupation) => occupation.actions.length !== 0)
    .map(({ startTime, endTime, actions, ...occupation }) => ({
      ...occupation,
      startTime: DateTime.max(startTime, actions[0].startTime),
      endTime: DateTime.min(endTime, actions.at(-1)!.endTime),
      actions,
    }));
}

function actionFilter(action: Action): boolean {
  return action.type !== "Teleport" && action.endTime.diff(action.startTime).toMillis() !== 0;
}
